import { useEffect, useState } from "react";
import { getPerformanceStatus } from "../../../services/clearing/station-performance";

/**
 * The earliest month already computed, or null when unknown (none computed yet, or the status call
 * failed). Null means "no lower bound": a failed lookup must not stop a reader choosing a month.
 */
export const useEarliestComputedMonth = (): string | null => {
  const [earliest, setEarliest] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const result = await getPerformanceStatus();
      if (cancelled) return;
      const months: { yearMonth: string }[] = result?.success ? (result.data?.months ?? []) : [];
      setEarliest(months.length ? months.map((m) => m.yearMonth).sort()[0] : null);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return earliest;
};
